module.exports = __webpack_public_path__ + "img/image@2x (2).cc358d87.webp";